import { LoadingSpinner } from './LoadingSpinner';

/**
 * `LoadingSpinner` centered in a full-viewport wrapper. This is the "the
 * whole screen is just a loading state" pattern used for initial app load
 * and route-level suspense fallbacks — extracted as the one place that
 * defines it so call sites can't drift apart (e.g. one showing a centered
 * spinner and another showing an unstyled one top-left).
 */
export const FullScreenLoadingSpinner = () => (
  <div
    data-testid="full-screen-loading-spinner"
    className="flex items-center justify-center h-dvh w-screen"
  >
    <LoadingSpinner />
  </div>
);
